<template>
  <div class="pay-money">
    <div class="pay-money__unit">{{ price.prefix }}</div>
    <div class="pay-money__number">{{ price.value }}</div>
  </div>
</template>

<script setup lang="ts" name="PayMoney">
import { formatPrice } from '@rendora/common/utils/transform';
import { computed } from 'vue';
const props = defineProps<{ text: number }>();

const price = computed(() => formatPrice(props.text));
</script>

<style lang="scss">
.pay-money {
  display: flex;
  color: var(--x-error-6);
  font-size: 28px;
  font-weight: 600;
  line-height: 42px;
}
</style>
